document.addEventListener('DOMContentLoaded', function () {
    function waitForElement(selector, { timeout = 1000, root = document.body } = {}) {
        return new Promise(resolve => {
            // 1️⃣ 立即检查是否已存在
            const existing = root.querySelector(selector);
            if (existing) return resolve(existing);
        
            // 2️⃣ 启动 MutationObserver
            const observer = new MutationObserver(() => {
                const el = root.querySelector(selector);
                if (el) {
                    clearTimeout(timer);
                    observer.disconnect();
                    resolve(el);
                }
            });
            observer.observe(root, { childList: true, subtree: true });
        
            // 3️⃣ 超时自动停止监听 - 超时后不再监听，直接返回
            const timer = setTimeout(() => {
                observer.disconnect();
                // 超时后最后尝试一次查询，不使用监听
                const finalCheck = root.querySelector(selector);
                resolve(finalCheck); // 返回元素或 null
            }, timeout);
        });
    }
      
    waitForElement('.shopify-pc__banner__dialog').then(el => {
        if (el) {
            setTimeout(() => {
                el.classList.add('show');
            }, 8000);
        }
    });

    const ImageLoader = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
        const img = entry.target;
        
        // 加载 src
        if (img.hasAttribute('data-src')) {
            img.src = img.getAttribute('data-src');
            img.removeAttribute('data-src');
        }
        
        // 加载 srcset
        if (img.hasAttribute('data-srcset')) {
            img.srcset = img.getAttribute('data-srcset');
            img.removeAttribute('data-srcset');
        }
        
        observer.unobserve(img);  
        
        }
    });
    }, {
    rootMargin: "300px", // 预加载距离视口 300px 的图片
    });
    
    const images = document.querySelectorAll('.yg-lazy-load-img');
    console.log('images',images);
    
    images.forEach(img => ImageLoader.observe(img));

    const iframeLoader = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
            const iframe = entry.target;
            iframe.src = iframe.getAttribute('data-src');
            iframe.removeAttribute('data-src');
            observer.unobserve(iframe);
            }
        });
        }, {
        rootMargin: "300px", // 预加载距离视口 300px 的 iframe
    });

    const iframes = document.querySelectorAll('.yg-lazy-load-iframe');
    iframes.forEach(iframe => iframeLoader.observe(iframe));
    

    function productDetailInit() {
        document.querySelectorAll('.yg-detail-container').forEach((item) => {
          item.addEventListener('click', () => {
            // 如果带有类名 action-full 先全部收起
            if(item.classList.contains('action-full')) {
              // 先移除所有元素上的 active 类
              document.querySelectorAll('.yg-detail-container.active').forEach(activeItem => {
                activeItem.classList.remove('active');
              });
            }
      
            item.classList.toggle('active');
          });
        });
      
        const contents = document.querySelectorAll('.yg-detail-main');
        contents.forEach(content => {
          content.addEventListener('click', function(e) {
            e.stopPropagation();
          });
        });
      }
      
      function copyElementText(elementId, hintId) {
        const element = document.getElementById(elementId);
        const hint = document.getElementById(hintId)
      
        const textToCopy = element.textContent || element.innerText;
        navigator.clipboard.writeText(textToCopy).then(function() {
          console.log('successfully copy')
          hint.style.display = 'unset'
          setTimeout(() => {
            hint.style.display = 'none'
          }, 1500)
        })
      }
      
      function activeInboxChat() {
        // document.querySelector("#ShopifyChat").contentWindow.document.querySelector(".chat-toggle--bottom-right").click();
        document.querySelector("#ShopifyChat").shadowRoot.querySelector(".chat-toggle--bottom-right").click();
      }
      
      function productColorSwatchSplit () {
        // 获取所有带有 product-id 的元素
        const productElements = document.querySelectorAll('.grid-product__colors[product-id]');
        if(!productElements) {
          return;
        }
        const productIds = [];
      
        // 遍历这些元素并提取 product-id
        productElements.forEach(function (element) {
          const productId = element.getAttribute('product-id');
          if (productId) {
            productIds.push(productId);
          }
        });
      
        // 输出所有 product-id
        console.log(productIds);
      
        for (let i = 0; i < productIds.length; i++) {
          const productId = productIds[i];
          const productContainer = document.querySelector(`.grid-product__colors[product-id="${productId}"]`);
          if (productContainer) {
            const links = productContainer.querySelectorAll('a');
            // 超出 4 个 的隐藏，同时激活提示
            if (links.length > 4) {
              productContainer.setAttribute('data-yg-links-count', links.length - 4);
              const hint = document.querySelector(`.yg-hidden-hint[yg-hint-product-id="${productId}"]`);
              const hintSpan = hint.querySelector('span');
      
              hintSpan.textContent = `+${links.length - 4}`;
      
              hint.style.display = '';
              for (let j = 4; j < links.length; j++) {
                const item = links[j];
                item.style.display = 'none';
              }
      
              // 回显
              hint.addEventListener('click', function () {
                for (let j = 4; j < links.length; j++) {
                  const item = links[j];
                  item.style.display = '';
                }
                hint.style.display = 'none';
              });
            }
          }
        }
      }
      
      /* ------------ 初始化 ------------ */
      productDetailInit();
      // productColorSwatchSplit();
});